module.exports = __webpack_public_path__ + "static/media/Screenshot1024page6.ab3f6975.png";